/* Copyright 2021, Milkdown by Mirone. */
import emojiRegex from 'emoji-regex';
import { parse } from './parse';
const regex = emojiRegex();
const isParent = (node) => !!node.children;
const isLiteral = (node) => !!node.value;
function flatMap(ast, fn) {
    return transform(ast, 0, null)[0];
    function transform(node, index, parent) {
        if (isParent(node)) {
            const out = [];
            for (let i = 0, n = node.children.length; i < n; i++) {
                const xs = transform(node.children[i], i, node);
                if (xs) {
                    for (let j = 0, m = xs.length; j < m; j++) {
                        out.push(xs[j]);
                    }
                }
            }
            node.children = out;
        }
        return fn(node, index, parent);
    }
}
export const twemojiPlugin = () => {
    function transformer(tree) {
        flatMap(tree, (node) => {
            if (!isLiteral(node)) {
                return [node];
            }
            const value = node.value;
            const output = [];
            let match;
            let str = value;
            while ((match = regex.exec(str))) {
                const { index } = match;
                const emoji = match[0];
                if (index > 0) {
                    output.push(Object.assign(Object.assign({}, node), { value: str.slice(0, index) }));
                }
                output.push(Object.assign(Object.assign({}, node), { value: parse(emoji), type: 'emoji' }));
                str = str.slice(index + emoji.length);
            }
            if (str.length) {
                output.push(Object.assign(Object.assign({}, node), { value: str }));
            }
            return output;
        });
    }
    return transformer;
};
//# sourceMappingURL=remark-twemoji.js.map